import { Skeleton } from "../ui/skeleton";

export default function AutostackOverallSkeleton() {
  return (
    <div className="px-6 md:px-14 py-6 bg-bg-light-gray rounded-t-2xl space-y-8 h-[calc(100vh-100px)]">
      <div className="flex items-stretch flex-wrap md:flex-nowrap gap-6 w-full">
        <div className="w-full md:w-1/2 flex">
          <div className="bg-white rounded-2xl p-6 border border-bg-section space-y-4 w-full">
            <div className="flex justify-between items-center">
              <Skeleton className="h-5 w-40 bg-gray-300" />
              <Skeleton className="h-4 w-20 bg-gray-300" />
            </div>

            <div className="space-y-2">
              <Skeleton className="h-8 w-48 bg-gray-300" />
              <Skeleton className="h-5 w-32 bg-gray-300" />
            </div>

            <Skeleton className="h-80 w-full rounded-lg bg-gray-300" />
          </div>
        </div>

        <div className="w-full md:w-1/2 flex">
          <div className="bg-white rounded-2xl p-6 border border-bg-section w-full">
            <div className="flex flex-col">
              <Skeleton className="h-6 w-24 bg-gray-300 mb-4" />

              <div className="space-y-4">
                {Array.from({ length: 3 }).map((_, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-3 p-3 rounded-lg"
                  >
                    <Skeleton className="h-10 w-10 rounded-full bg-gray-300" />
                    <div className="flex-1 space-y-2">
                      <Skeleton className="h-4 w-32 bg-gray-300" />
                      <Skeleton className="h-3 w-24 bg-gray-300" />
                    </div>
                    <div className="text-right space-y-2">
                      <Skeleton className="h-4 w-20 bg-gray-300" />
                      <Skeleton className="h-3 w-16 bg-gray-300" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
